import React from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

import InputField from 'Pods/Shared/InputField'
import { run, RuleRunner } from 'Pods/Shared/RuleRunner'
import { required, isEmail, isLimitedLength } from 'Pods/Shared/Rules/Rules'
import Icon from 'Pods/Shared/Icon/Icon'

const fieldValidations = [
  RuleRunner('email', 'Email', required),
]

class GuestCheckout extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.getInitialState(props)

    this.errorFor = this.errorFor.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
  }

  componentDidMount() {
    this.setState({ validationErrors: run(this.state, fieldValidations) })
  }

  getInitialState(props) {
    return {
      email: props.email || '',
      validationErrors: {},
    }
  }

  errorFor(field) {
    return this.state.validationErrors[field] || ''
  }

  handleInputChange(e) {
    const newState = update(this.state, { [e.target.name]: { $set: e.target.value } })
    newState.validationErrors = run(newState, fieldValidations)

    this.setState(newState)
    this.props.updateEmail(newState.email)
  }

  handleSubmit(e) {
    e.preventDefault()

    this.setState({ showErrors: true })

    if (Object.getOwnPropertyNames(this.state.validationErrors).length !== 0) {
      return null
    }

    axios.post('/guests/sessions', { email: this.state.email })
      .then(this.onSubmitSuccess)
      .catch(this.onSubmitFailure)
  }

  onSubmitSuccess(response) {
    if (typeof response.data === 'string') {
      // Security tool asks for verification.
      document.write(response.data)
    } else {
      window.location = `/${window.location.pathname.split('/')[1]}/checkout/payment`
    }
  }

  onSubmitFailure(xhr) {
    App.events.publish('app:notification:flash:error', [xhr.response.data.message])
  }

  render() {
    return (
      <div className="guest-user-checkout-container">
        <form onSubmit={this.handleSubmit} id="checkout-guest" action="/guests/sessions.json">
          <div className="checkout-guest">
            <div className="checkout-guest__email">
              <div className="form-group form-group-grey">
                <InputField
                  label="Email"
                  id="guest_email"
                  name="email"
                  type="text"
                  errorText={this.errorFor('email')}
                  showError={this.state.showErrors}
                  value={this.state.email}
                  formClassName="form-group-grey"
                  inputClassName="form-control-grey form-control--with-placeholder"
                  placeholder="email@example.org"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>

            {this.props.checkbox}

            <div className="session-actions u-text-right">
              <button className="btn btn-transparent">
                Continue as guest
                <span className="u-ml10">
                  <Icon type={['fas', 'chevron-right']} color="green-dark" />
                </span>
              </button>
            </div>
          </div>
          <p className="explanation u-mb0">Note: e-mail address is for sending details of your order only.</p>
        </form>
      </div>
    )
  }
}

GuestCheckout.propTypes = {
  email: PropTypes.string,
  checkbox: PropTypes.node,
  updateEmail: PropTypes.func,
}

GuestCheckout.defaultProps = {
  email: '',
  checkbox: null,
  updateEmail: () => {},
}

export default GuestCheckout
